import BaseTypedController from "ips/ac/base/controller/BaseTypedController";
import Sorter from "sap/ui/model/Sorter";
import formatter from "ips/ac/model/formatter";
import ListHandler from "ips/ac/base/handler/ListHandler";
import { SearchField$SearchEvent } from "sap/m/SearchField";
import { ListItemBase$PressEvent } from "sap/m/ListItemBase";

/**
 * @namespace ips.ac.data.user.invitation-token
 */
export default class UserInvitationTokenList extends BaseTypedController {

  public formatter = formatter;

  private listHandler: ListHandler;

  public onInit() {
    super.onInit();

    this.listHandler = new ListHandler(this, {
      entitySet: "UserInvitationTokens",
      detailRoute: "employee-invitation-detail",
      sorter: new Sorter("CreatedOn"),
    });
    this.listHandler.init();
  }

  public onFilterTable(oEvent: SearchField$SearchEvent) {
    this.listHandler.onFilterTable(oEvent);
  }

  public onItemPress(oEvent: ListItemBase$PressEvent) {
    this.listHandler.onItemPress(oEvent);
  }

  public onAdd() {
    const config = {
      mode: "create",
    };

    this.setRouteDisplayData("employeecreate", config);
    this.navTo("employeecreate", config);
  }
}